import { useMemo, useCallback } from 'react'
import { useStateWithRef } from './useStateWithRef'

export const useRegisteredComponents = () => {
  const [registeredComponents, setRegisteredComponents, registeredComponentsRef] = useStateWithRef<
    string[]
  >([])
  const registerComponent = useCallback(() => {
    const id = crypto.randomUUID()
    setRegisteredComponents(currentRegisteredComponents => [...currentRegisteredComponents, id])
    return () => {
      setRegisteredComponents(currentRegisteredComponents => {
        const indexToRemove = currentRegisteredComponents.indexOf(id)
        const nextRegisteredComponents = [
          ...currentRegisteredComponents.slice(0, indexToRemove),
          ...currentRegisteredComponents.slice(indexToRemove + 1),
        ]
        return nextRegisteredComponents
      })
    }
  }, [setRegisteredComponents])
  const hasRegisteredComponents = useMemo(
    () => !!registeredComponents.length,
    [registeredComponents],
  )
  return {
    registerComponent,
    hasRegisteredComponents,
    registeredComponents,
    registeredComponentsRef,
  }
}
